
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import AnimateInView from '@/components/ui/animate-in-view';

const FibreCTA = () => {
  return (
    <section aria-labelledby="fibre-cta-heading" className="section bg-forti-fi-charcoal py-[47px] bg-zinc-600 bg-[zinc-6001]">
      <div className="container mx-auto text-center max-w-3xl">
        <AnimateInView>
          <h2 id="fibre-cta-heading" className="mb-6 text-white">
            Zone Your Property
          </h2>
          <p className="mb-8 text-forti-fi-lavender text-xl">
            Take the first step toward invisible, uncompromising protection with a confidential consultation.
          </p>
          <Button asChild size="lg" className="bg-forti-fi-teal hover:bg-forti-fi-teal/90 text-white">
            <Link to="/contact">
              Schedule a Consultation Today
            </Link>
          </Button>
        </AnimateInView>
      </div>
    </section>
  );
};

export default FibreCTA;
